import styled from '@emotion/styled';

import { colors, spacing, typography } from 'component-library';

export const ContainerCardWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;

export const ContainerDetailsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ContainerDetailsInnerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;
export const DetailsRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${spacing.xxsmall};
  flex-wrap: wrap;
`;
export const ButtonWrapper = styled('div')`
  display: flex;
  direction: row;
  height: ${spacing.mediumLow};
  justify-content: flex-start;
  gap: ${spacing.xsmall};
  margin-top: ${spacing.small};
`;

export const DetailsOtherContainerWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${spacing.tiny};
`;

export const MaterialOtherWrapper = styled.div`
  display: flex;
  max-width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;

  p {
    max-width: 100%;
  }
`;

export const ImageWrapper = styled.div`
  width: 173px;
  height: 116px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MaterialWrapper = styled.div`
  display: flex;
  flex-direction: row;

  max-width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const MaterialIdWrapper = styled.div`
  color: ${colors.primary.grey};
  margin-left: ${spacing.tiny};
  ${typography.other.inputLabel}
`;
